import { isNullish } from 'utils/nullish';

export const Base64 = Object.freeze({
  /**
   * @param str {string}
   * @return {string}
   * */
  encodeAsString(str) {
    if (isNullish(str)) {
      return str;
    }
    const uint8Array = new TextEncoder().encode(String(str));
    return window.btoa(Array.from(uint8Array, byte => String.fromCharCode(byte)).join(''));
  },

  /**
   * @param str {string}
   * @return {string}
   * */
  decodeAsString(str) {
    if (isNullish(str)) {
      return str;
    }
    const binaryString = window.atob(String(str));
    const uint8Array = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }
    return new TextDecoder().decode(uint8Array);
  },
});
